export default __webpack_public_path__ + "assets/carousel-remote-access.84cbb39bd114c7e5c40af2ad3320ef39.webp";